import React, { useState } from "react";
import { UploadZone, DownloadButton, ResetButton, loadImage } from "./_shared";
import { RotateCw, RotateCcw } from "lucide-react";

export default function RotateImage() {
  const [file, setFile] = useState(null);
  const [angle, setAngle] = useState(0);
  const [outUrl, setOutUrl] = useState(null);

  const process = async (f, deg) => {
    const { img } = await loadImage(f);
    const rad = (deg * Math.PI) / 180;
    const sin = Math.abs(Math.sin(rad)), cos = Math.abs(Math.cos(rad));
    const w = img.naturalWidth * cos + img.naturalHeight * sin;
    const h = img.naturalWidth * sin + img.naturalHeight * cos;
    const canvas = document.createElement("canvas");
    canvas.width = w; canvas.height = h;
    const ctx = canvas.getContext("2d");
    ctx.translate(w / 2, h / 2);
    ctx.rotate(rad);
    ctx.drawImage(img, -img.naturalWidth / 2, -img.naturalHeight / 2);
    canvas.toBlob((blob) => {
      if (outUrl) URL.revokeObjectURL(outUrl);
      setOutUrl(URL.createObjectURL(blob));
    }, "image/png", 0.95);
  };

  const handleFile = async (f) => { setFile(f); setAngle(90); await process(f, 90); };
  const rotate = (delta) => { const a = (angle + delta) % 360; setAngle(a); process(file, a); };
  const reset = () => { setFile(null); setOutUrl(null); setAngle(0); };

  if (!file) return <UploadZone onFile={handleFile} />;
  return (
    <div className="space-y-6">
      <div className="rounded-2xl border border-slate-200 dark:border-white/10 overflow-hidden bg-slate-50 dark:bg-[#0b0c0e] p-4">
        {outUrl && <img src={outUrl} alt="rotated" className="w-full max-h-96 object-contain" />}
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <button onClick={() => rotate(-90)} data-testid="rotate-left" className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg border border-slate-200 dark:border-white/10 text-slate-700 dark:text-slate-200 text-sm hover:bg-slate-50 dark:hover:bg-white/5"><RotateCcw size={14} /> −90°</button>
        <button onClick={() => rotate(90)} data-testid="rotate-right" className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg border border-slate-200 dark:border-white/10 text-slate-700 dark:text-slate-200 text-sm hover:bg-slate-50 dark:hover:bg-white/5"><RotateCw size={14} /> +90°</button>
        <button onClick={() => rotate(180)} className="px-4 py-2.5 rounded-lg border border-slate-200 dark:border-white/10 text-slate-700 dark:text-slate-200 text-sm hover:bg-slate-50 dark:hover:bg-white/5">180°</button>
        <span className="text-sm text-slate-500 dark:text-slate-400">Angle: {angle}°</span>
        <DownloadButton href={outUrl} filename={`rotated-${file.name}`}>Download</DownloadButton>
        <ResetButton onClick={reset} />
      </div>
    </div>
  );
}
